<template>
    <div class="ad-image-container">
        <el-carousel trigger="click" :height="carouselHeight">
            <el-carousel-item v-for="item in advertise.uri" :key="item">
                <el-image :src="item" class="ad-image-item" :class="scene">
                    <div slot="error" class="image-slot">
                        <img :src="item">
                    </div>
                </el-image>
            </el-carousel-item>
        </el-carousel>
    </div>
</template>
<script>
export default {
    name: 'article-element',
    props: {
        advertise: {
            type: Object,
            required: true
        },
        scene: String,
    },
    computed: {
        carouselHeight() {
            if (this.scene=="feedList") {
                return '210px'
            } else {
                return '310px'
            }
        }
    }
}
</script>
<style scoped>
.ad-image-container {
    width: 550px;
    margin: 5px auto;
    background-color: azure;
}

.ad-image-item {
    width: 550px;
    height: 210px;
}

.ad-image-item.feedDetail {
    height: 310px;
}

</style>